const TEXTS = {
  signed_up_success: "You have successfully created an account",
  logged_in_success: "You have been successfully logged in",
  logged_in_failure: "Incorrect username or password",
  logged_out_success: "You have been successfully logged out",
  account_edited_success: "You have successfully changed account settings",
  custom_select_nothing_selected: "You didn't choose anything :-(",
  input: {
    empty: "You didn't type anything :-(",
    user_name_empty: "Please fill in your username",
    user_email_empty: "Please fill in your email",
    user_password_empty: "Please fill in your password",
    user_password_short: "Password must have at least 6 characters"
  }
};

export default TEXTS;
